import { render } from "./Number.vue?vue&type=template&id=b307643e"
import script from "./Number.vue?vue&type=script&setup=true&lang=js"
export * from "./Number.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b307643e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b307643e', __exports__)) {
    api.reload('b307643e', __exports__)
  }
  
  module.hot.accept("./Number.vue?vue&type=template&id=b307643e", () => {
    api.rerender('b307643e', render)
  })

}


export default __exports__